import { Paragraph } from '@eggplant/pattern-library'

const TestCaseNoRunResult = () =>
  <Paragraph>
    Test case never run before
  </Paragraph>

export default TestCaseNoRunResult
